<template>
  <div class="login-container">
    <!-- 左侧品牌展示区 -->
    <div class="left-section">
      <div class="bg-gradient"></div>
      <div class="bg-grid"></div>
      
      <div class="brand-content">
        <div class="logo-section">
          <div class="logo-box">
            <div class="logo-icon">
              <i class="el-icon-s-shop"></i>
            </div>
            <div class="logo-glow"></div>
          </div>
          <h1 class="brand-title">租赁管理系统</h1>
          <p class="brand-desc">专业高效的租赁业务管理平台</p>
        </div>
        
        <div class="stats-section">
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-building"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">500+</div>
              <div class="stat-label">合作门店</div>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-shopping-cart"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">10万+</div>
              <div class="stat-label">租赁订单</div>
            </div>
          </div>
          <div class="stat-card">
            <div class="stat-icon">
              <i class="el-icon-users"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">5万+</div>
              <div class="stat-label">服务用户</div>
            </div>
          </div>
        </div>

        <div class="features">
          <div class="feature-card">
            <div class="feature-icon-wrap">
              <i class="el-icon-shield"></i>
            </div>
            <div class="feature-content">
              <h3>企业级安全</h3>
              <p>端到端加密，多重安全防护</p>
            </div>
          </div>
          <div class="feature-card">
            <div class="feature-icon-wrap">
              <i class="el-icon-zip"></i>
            </div>
            <div class="feature-content">
              <h3>智能合约</h3>
              <p>自动生成电子租赁合同</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 右侧登录区 -->
    <div class="right-section">
      <div class="login-wrapper">
        <div class="login-card">
          <!-- 顶部Logo区 -->
          <div class="login-header">
            <div class="login-logo">
              <i class="el-icon-s-shop"></i>
            </div>
            <h2>管理员登录</h2>
            <p class="login-desc">请输入账号密码登录系统</p>
          </div>

          <!-- 登录表单 -->
          <el-form ref="loginForm" :model="form" :rules="rules" class="login-form">
            <el-form-item prop="username">
              <div class="input-group">
                <span class="input-icon">
                  <i class="el-icon-user"></i>
                </span>
                <input
                  v-model="form.username"
                  class="native-input"
                  placeholder="账号"
                  @keyup.enter="focusPassword"
                />
              </div>
            </el-form-item>

            <el-form-item prop="password">
              <div class="input-group">
                <span class="input-icon">
                  <i class="el-icon-lock"></i>
                </span>
                <input
                  ref="passwordInput"
                  v-model="form.password"
                  class="native-input"
                  :type="passwordVisible ? 'text' : 'password'"
                  placeholder="密码"
                  @keyup.enter="focusCaptcha"
                />
                <span class="toggle-password" @click="passwordVisible = !passwordVisible">
                  <i :class="passwordVisible ? 'el-icon-view' : 'el-icon-hide'"></i>
                </span>
              </div>
            </el-form-item>

            <el-form-item prop="captchaCode">
              <div class="input-group captcha-group">
                <span class="input-icon">
                  <i class="el-icon-key"></i>
                </span>
                <input
                  v-model="form.captchaCode"
                  class="native-input"
                  placeholder="验证码"
                  @keyup.enter="handleLogin"
                />
                <div class="captcha-wrapper" @click="refreshCaptcha" title="点击刷新">
                  <img :src="captchaImage" class="captcha-img" />
                </div>
              </div>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                :loading="loading"
                class="login-btn"
                @click="handleLogin"
              >
                <span v-if="!loading">登 录</span>
                <span v-else>登录中...</span>
              </el-button>
            </el-form-item>
          </el-form>

          <!-- 底部 -->
          <div class="login-footer">
            <span>Copyright &copy; {{ year }} 租赁管理系统</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login, getCaptcha } from '@/api/auth'

export default {
  name: 'Login',
  data() {
    return {
      form: {
        username: '',
        password: '',
        captchaId: '',
        captchaCode: ''
      },
      captchaImage: '',
      passwordVisible: false,
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captchaCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loading: false,
      year: new Date().getFullYear()
    }
  },
  created() {
    this.refreshCaptcha()
  },
  methods: {
    focusPassword() {
      this.$refs.passwordInput.focus()
    },
    focusCaptcha() {
      // trigger enter to captcha
    },
    async refreshCaptcha() {
      try {
        const res = await getCaptcha()
        if (res.code === 200) {
          this.form.captchaId = res.data.captchaId
          this.captchaImage = res.data.captchaImage
        }
      } catch (e) {
        console.error('获取验证码失败', e)
      }
    },
    async handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await login(this.form)
          if (res.code === 200) {
            const data = res.data
            localStorage.setItem('admin_token', data.token)
            localStorage.setItem('admin_info', JSON.stringify({
              admin: data.admin,
              role: data.role,
              menus: data.menus,
              serviceProviderName: data.serviceProviderName || '',
              miniAppName: data.miniAppName || '',
              miniAppAppId: data.miniAppAppId || ''
            }))
            this.$message.success('登录成功')
            setTimeout(() => {
              this.$router.push('/dashboard')
            }, 500)
          } else {
            this.$message.error(res.message || '登录失败')
            this.refreshCaptcha()
            this.form.captchaCode = ''
          }
        } catch (e) {
          this.$message.error(e.message || '登录失败')
          this.refreshCaptcha()
          this.form.captchaCode = ''
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  width: 100%;
  overflow: hidden;
}

/* 左侧品牌展示区 */
.left-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 30px 40px;
  max-height: 100vh;
}

.left-section .bg-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 30%, #ec4899 70%, #f43f5e 100%);
}

.left-section .bg-grid {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 60px 60px;
}

.brand-content {
  position: relative;
  z-index: 1;
  color: #fff;
  width: 100%;
  max-width: 480px;
}

.logo-section {
  text-align: center;
  margin-bottom: 30px;
}

.logo-box {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 30px;
}

.logo-icon {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.logo-icon i {
  font-size: 48px;
  color: #fff;
}

.logo-glow {
  position: absolute;
  inset: -20px;
  background: radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%);
  border-radius: 50%;
  animation: pulse 3s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 0.8; }
}

.brand-title {
  font-size: 42px;
  font-weight: 700;
  margin: 0 0 16px;
  letter-spacing: 3px;
}

.brand-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

/* 统计数据区 */
.stats-section {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 25px;
}

.stat-card {
  flex: 1;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 24px 16px;
  text-align: center;
  transition: all 0.3s ease;
}

.stat-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-4px);
}

.stat-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon i {
  font-size: 24px;
}

.stat-value {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

/* 功能特性区 */
.features {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feature-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  transition: all 0.3s ease;
}

.feature-card:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateX(8px);
}

.feature-icon-wrap {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255,255,255,0.2), rgba(255,255,255,0.05));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-icon-wrap i {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
}

.feature-content h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 6px;
}

.feature-content p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

/* 右侧登录区 */
.right-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 20px;
  max-height: 100vh;
}

.login-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.05);
}

/* 登录头部 */
.login-header {
  text-align: center;
  margin-bottom: 25px;
}

.login-logo {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 16px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.3);
}

.login-logo i {
  font-size: 32px;
  color: #fff;
}

.login-header h2 {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
}

.login-desc {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* 输入框组 */
.input-group {
  display: flex !important;
  align-items: center !important;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 0 16px;
  height: 52px;
  box-sizing: border-box;
  transition: all 0.3s;
}

.input-group:focus-within {
  background: transparent;
  border-color: #6366f1;
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}

.input-icon {
  display: inline-block !important;
  width: 20px !important;
  min-width: 20px !important;
  max-width: 20px !important;
  height: 20px !important;
  line-height: 20px !important;
  text-align: center !important;
  color: #94a3b8;
  font-size: 18px;
  flex-shrink: 0 !important;
  flex-grow: 0 !important;
  margin-right: 12px !important;
}

.native-input {
  flex: 1 !important;
  min-width: 0 !important;
  height: 100% !important;
  border: none !important;
  background: transparent !important;
  outline: none !important;
  color: #1e293b;
  font-size: 15px;
  padding: 0 !important;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
}

.native-input::placeholder {
  color: #94a3b8;
}

.toggle-password {
  display: inline-block !important;
  width: 20px !important;
  min-width: 20px !important;
  max-width: 20px !important;
  height: 20px !important;
  line-height: 20px !important;
  text-align: center !important;
  cursor: pointer;
  color: #94a3b8;
  font-size: 18px;
  flex-shrink: 0 !important;
  flex-grow: 0 !important;
  margin-left: 12px !important;
  transition: color 0.3s;
}

.toggle-password:hover {
  color: #6366f1;
}

/* 验证码组 */
.captcha-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.captcha-group .el-input {
  flex: 1;
}

.captcha-wrapper {
  flex-shrink: 0;
  height: 52px;
  width: 140px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s;
}

.captcha-wrapper:hover {
  border-color: #6366f1;
  transform: scale(1.02);
}

.captcha-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

/* 表单间距 */
.login-form .el-form-item {
  margin-bottom: 36px;
}

/* 验证错误提示 */
.login-form .el-form-item__error {
  padding-top: 4px;
  line-height: 1.4;
  white-space: normal;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 52px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  letter-spacing: 4px;
  transition: all 0.3s;
  margin-top: 10px;
}

.login-btn:hover {
  background: linear-gradient(135deg, #7c7fff, #a78bfa);
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.4);
  transform: translateY(-2px);
}

.login-btn:active {
  transform: translateY(0);
}

/* 底部版权 */
.login-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}

.login-footer span {
  font-size: 13px;
  color: #94a3b8;
}

/* 响应式 */
@media (max-width: 900px) {
  .login-container {
    flex-direction: column;
  }
  
  .left-section {
    width: 100%;
    padding: 50px 30px;
    min-height: 500px;
  }
  
  .right-section {
    width: 100%;
    padding: 40px 24px;
  }
  
  .login-card {
    padding: 36px 28px;
  }
  
  .brand-title {
    font-size: 32px;
  }
  
  .stats-section {
    gap: 12px;
  }
  
  .stat-card {
    padding: 18px 12px;
  }
  
  .stat-value {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .left-section {
    padding: 40px 20px;
    min-height: 450px;
  }
  
  .right-section {
    padding: 24px 16px;
  }
  
  .login-card {
    padding: 28px 20px;
  }
  
  .brand-title {
    font-size: 28px;
  }
  
  .stats-section {
    flex-direction: column;
  }
  
  .stat-card {
    flex-direction: row;
    justify-content: flex-start;
    text-align: left;
    gap: 16px;
  }
  
  .stat-icon {
    margin: 0;
  }
  
  .features {
    gap: 16px;
  }
  
  .feature-card {
    padding: 16px;
  }
}
</style>

<style>
/* 非 scoped 样式 - 移除输入框背景色 */
.login-form .input-group {
  background: transparent !important;
}

.login-form .input-group:focus-within {
  background: transparent !important;
}

.login-form .input-group .native-input {
  background: transparent !important;
}

/* 移除浏览器自动填充的背景色 */
.login-form .input-group .native-input:-webkit-autofill,
.login-form .input-group .native-input:-webkit-autofill:hover,
.login-form .input-group .native-input:-webkit-autofill:focus,
.login-form .input-group .native-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: #1e293b !important;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
